
import Cookies from 'js-cookie';
import React, { useContext} from 'react';
import axios from 'axios';
const SESSION_KEY = "";
const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

export class HttpService {


    headers = {
    }

    constructor(url_prefix = "") {
        this.url_prefix = url_prefix
        this.getHeaders()
    }

    async get(queryParams) {
        try {

            const { data } = await axios.get(ROOT_URL + this.url_prefix + this.mapQueryParams(queryParams), {
                headers: this.headers
            });

            return data.data;
            
        } catch (error) {
            console.log(error)
            return null
        }
    }

    async post(params) {
        
        try {
            const response = await axios.post(ROOT_URL + this.url_prefix, params, {headers: this.headers});

            return response;

        } catch (error) {
            console.log(error);
            return null;
        }

    }

    async put(params) {

        try {
            
            const response = await axios.put(ROOT_URL + this.url_prefix, params,  { headers: this.headers} );
            
            return response;

        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async remove(params) {
        
        try {

            const response = await axios.delete(ROOT_URL + this.url_prefix, { data: params , headers: this.headers });
            
            return response;

        } catch (error) {
            console.log(error)
            return null
        }
    }

    getHeaders() {
        
        this.headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": `Bearer ${Cookies.get('token')}`
        }
    }

    mapQueryParams(queryParams) {
        
        return (queryParams)
            ? "?" + Object.keys(queryParams).map(function (key) { return key + '=' + queryParams[key] }).join('&')
            : "";
    }
}